(() => {
window.s18 = function() {
    /**
     * Utility functions for basic DOM manipulation. Taken from:
     * https://plainjs.com/javascript/
     */ let svAddClass, svRemoveClass;
    if ("classList" in document.documentElement) {
        svAddClass = function(el, className) {
            el.classList.add(className);
        };
        svRemoveClass = function(el, className) {
            el.classList.remove(className);
        };
    } else {
        svAddClass = function(el, className) {
            if (!hasClass(el, className)) el.className += " " + className;
        };
        svRemoveClass = function(el, className) {
            el.className = el.className.replace(new RegExp("\\b" + className + "\\b", "g"), "");
        };
    }
    /**
     * Debounce functions for better performance
     * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Function} fn The function to debounce
     */ function svDebounce(fn) {
        // Setup a timer
        var timeout;
        // Return a function to run debounced
        return function() {
            // Setup the arguments
            var context = this;
            var args = arguments;
            // If there's a timer, cancel it
            if (timeout) window.cancelAnimationFrame(timeout);
            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(function() {
                fn.apply(context, args);
            });
        };
    }
    /**
     * 
     * 
     * @param {object} selectors
     * @param {string} selectors.target - CSS Selector for main element
     * @param {string} selectors.open - CSS Selector for open trigger
     * @param {string} selectors.close - CSS Selector for close trigger
     * @param {object} params
     * @param {string} params.active - CSS class defining active state. Use CSS
     * keyframes for animation. Defaults to 'active'.
     * @param {string} params.rest - CSS class defining rest state. Use CSS
     * keyframes for animation. Defaults to 'rest'.
     * @param {number} params.breakpoint - Auto-hide the target at values above
     * this number. Set to 0 to ignore. Intended for hiding mobile menus if the
     * window size grows, but use for whatever :)
     */ function overlay(selectors, params) {
        let el = {};
        // Turn provided selectors into elements
        Object.keys(selectors).map((key)=>{
            el[key] = document.querySelector(selectors[key]);
        });
        // Set some defaults for params. Not all have defaults.
        params = params || {};
        params.active = params.active || "active";
        params.rest = params.rest || "rest";
        params.breakpoint = params.breakpoint || 0;
        // Helpers
        function openTarget(e) {
            svRemoveClass(el.target, params.rest);
            svAddClass(el.target, params.active);
        }
        function closeTarget(e) {
            svRemoveClass(el.target, params.active);
            svAddClass(el.target, params.rest);
        }
        function closeTargetOnResize(e) {
            if (window.innerWidth > params.breakpoint) closeTarget(e);
        }
        // Set open and close listeners
        el.open.addEventListener("click", function(e) {
            e.preventDefault();
            openTarget();
        });
        el.close.addEventListener("click", function(e) {
            e.preventDefault();
            closeTarget();
        });
        // Close target when sizing up
        if (params.breakpoint) {
            let debouncedCloseOverlay = svDebounce(closeTargetOnResize);
            window.addEventListener("resize", debouncedCloseOverlay);
        }
    }
    /**
     * Message provides an interface for closing elments on the page from a custom
     * trigger. It's useful for banners, messages etc.
     * 
     * By default, keeps elemenets closed between sessions.
     * 
     * @param {object} selectors
     * @param {string} selectors.target - CSS Selector for main element
     * @param {string} selectors.close - CSS Selector for close trigger
     * @param {object} params
     * @param {bool} params.persistClose - If element has been closed, persist
     * state between sessions. Defaults to `true`.
     * @param {string} params.active - CSS class defining active state. Use CSS
     * keyframes for animation. Defaults to 'active'.
     * @param {string} params.rest - CSS class defining rest state. Use CSS
     * keyframes for animation. Defaults to 'rest'.
     */ function message(selectors, params) {
        let el = {};
        // Turn provided selectors into elements
        Object.keys(selectors).map((key)=>{
            el[key] = document.querySelector(selectors[key]);
        });
        // Set some defaults for params. Not all have defaults.
        params = params || {};
        params.persistClose = typeof params.persistClose !== "undefined" ? params.persistClose : true;
        params.active = params.active || "active";
        params.rest = params.rest || "rest";
        // Set storage item name
        let itemName = selectors.target.toLowerCase().replace(/[^a-z]+/g, "") + "-state-hide";
        // Methods
        function open(e) {
            svRemoveClass(el.target, params.rest);
            svAddClass(el.target, params.active);
        }
        function close(e) {
            svRemoveClass(el.target, params.active);
            svAddClass(el.target, params.rest);
            if (params.persistClose) saveCloseState();
        }
        function saveCloseState() {
            localStorage.setItem(itemName, "true");
        }
        function conditionallyOpen() {
            if (!localStorage.getItem(itemName)) open();
        }
        // Set close listener
        el.close.addEventListener("click", close);
        // Set initial show (or not) on load
        window.addEventListener("load", conditionallyOpen);
    }
    return {
        overlay: overlay,
        message: message
    };
}();

})();
//# sourceMappingURL=main.js.map
